export default Pathwright.module(
  "Content",
  function (ContentModule, App, Backbone, Marionette, $, _) {
    this.startWithParent = false

    window.App.addInitializer(() =>
      // Init sub modules
      require("./assessment/module").start()
    )

    window.App.reqres.setHandler("get:content:model", (contentType) =>
      require(`./${contentType}/models/${contentType}`)
    )

    return window.App.reqres.setHandler("get:content:view", (contentType) =>
      require(`./${contentType}/views/${contentType}`)
    )
  }
)
